/**
 * Singleton wrapper of setInterval and clearInterval web API's.
 */
class Interval {
  public intervals: ReturnType<typeof setInterval>[] = [];

  /**
   * Schedules repeated execution of callback every delay milliseconds.
   *
   * @param callback - The function to call when the timer elapses.
   * @param ms - The number of milliseconds to wait before calling the callback.
   */
  public set(callback: () => void, ms?: number) {
    const id = setInterval(callback, ms);
    this.intervals.push(id);

    return id;
  }

  /**
   * Clear a Timeout object created by set().
   *
   * @param id - index generated by set().
   */
  public clear(id: ReturnType<typeof setInterval>) {
    clearInterval(id);

    this.intervals = this.intervals.filter(intervalId => id !== intervalId);
  }

  /**
   * Clear all registered setInterval.
   */
  public clearAll() {
    this.intervals.forEach(id => {
      this.clear(id);
    });
  }
}

// eslint-disable-next-line import/prefer-default-export
export const interval = new Interval();
